import styled from "styled-components";

export const CarouselContainer = styled.div`
  display: flex;
  overflow: hidden;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
`;

export const SlideContainer = styled.div`
  display: flex;
  transition: transform 0.5s ease;
  transform: translateX(-${(props) => props.currentIndex * 100}%);
`;

export const Slide = styled.div`
  flex: 0 0 100%;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
`;